import React, { useMemo } from 'react'
import i18n from 'simple-react-i18n'
import moment from 'moment'
import PropTypes from 'prop-types'
import DtoWaterTurnsSlot from 'exploitations/dto/DtoWaterTurnsSlot'
import { Accordion, AccordionDetails, AccordionSummary, Grid2 } from '@mui/material'
import { groupBy } from 'lodash'
import WaterTurnsTable from 'exploitations/components/waterTurns/WaterTurnsTable'
import { shallowEqual, useSelector } from 'react-redux'
import { getYear } from 'utils/DateUtil'

const WaterTurnsAccordion = ({
    data = [],
    readMode = false,
    colors = [],
    onOpenUpdate = () => { },
    deleteWaterTurns = () => { },
    yearKey = '0000',
    onApply = () => { },
    defaultExpanded = false,
}) => {
    const currentYear = useMemo(() => getYear(moment.now()) === parseInt(yearKey), [yearKey])

    const {
        waterTurnsSlots,
    } = useSelector(store => ({
        waterTurnsSlots: store.AgriReducer.waterTurnsSlots,
    }), shallowEqual)
    const groupedSlotData = groupBy(data, 'idSlot')

    return (
        <Grid2 size={12}>
            <Accordion
                key={`panel_${yearKey ?? ''}`}
                defaultExpanded={defaultExpanded}
            >
                <AccordionSummary>
                    <Grid2 container alignItems='center'>
                        {yearKey !== 'undefined' && yearKey || i18n.notDefined}
                    </Grid2>
                </AccordionSummary>
                <AccordionDetails sx={{ paddingBottom: 0, paddingLeft: '10px', paddingRight: '10px' }}>
                    {Object.keys(groupedSlotData).map(idSlotKey => (
                        <Grid2 className='padding-bottom-1' key={`table_${idSlotKey}`}>
                            <WaterTurnsTable
                                slot={waterTurnsSlots.find(wts => wts.id === parseInt(idSlotKey)) || { nbSlots: 1, id: -1 }}
                                data={groupedSlotData[idSlotKey]}
                                readMode={readMode}
                                colors={colors}
                                openUpdate={onOpenUpdate}
                                onDelete={deleteWaterTurns}
                                onApply={onApply}
                                currentYear={currentYear}
                            />
                        </Grid2>
                    ))}
                </AccordionDetails>
            </Accordion>
        </Grid2 >
    )
}

WaterTurnsAccordion.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    slot: PropTypes.instanceOf(DtoWaterTurnsSlot),
    colors: PropTypes.shape({}),
    readMode: PropTypes.bool,
    defaultExpanded: PropTypes.bool,
    setOpenAdd: PropTypes.func,
    onOpenUpdate: PropTypes.func,
    deleteWaterTurns: PropTypes.func,
    onApply: PropTypes.func,
    yearKey: PropTypes.string,
}

export default WaterTurnsAccordion